import { BaseSensorWebComponent } from '../../../base/BaseSensorWebComponent';
import { AtlassianJiraConfluenceController } from '../controller/AtlassianJiraConfluenceController';
import { SensorType } from '../../../types/sensor-type';

export class AtlassianJiraConfluenceComponent extends BaseSensorWebComponent {
  public controller!: AtlassianJiraConfluenceController;
  public hasDetails = true;
  protected composedSensors = [SensorType.ATLASSIAN_JIRA, SensorType.ATLASSIAN_CONFLUENCE];
  public isOptional = true;
  public formNeedToBeEmptyForAddedSensor = true;
  public isComposed = true;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AtlassianJiraConfluenceController,
    });
  }

  public setEnabled(isEnabled: boolean): void {
    this.controller.setEnabledAllFields(isEnabled);
  }

  public disconnectedCallback(): void {
    this.controller.view.formGroupSubscription?.unsubscribe();
    super.disconnectedCallback();
  }

  public getDetails(): any[] {
    return this.controller.getDetails();
  }
}
